import { render, staticRenderFns } from "./MobileBigMap.vue?vue&type=template&id=a2b389e4&scoped=true"
import script from "./MobileBigMap.vue?vue&type=script&lang=js"
export * from "./MobileBigMap.vue?vue&type=script&lang=js"
import style0 from "./MobileBigMap.vue?vue&type=style&index=0&id=a2b389e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b389e4",
  null
  
)

export default component.exports